import { render, staticRenderFns } from "./BpmAutoDesformSetUse.vue?vue&type=template&id=dcb9dbf6&scoped=true&"
import script from "./BpmAutoDesformSetUse.vue?vue&type=script&lang=js&"
export * from "./BpmAutoDesformSetUse.vue?vue&type=script&lang=js&"
import style0 from "./BpmAutoDesformSetUse.vue?vue&type=style&index=0&id=dcb9dbf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb9dbf6",
  null
  
)

export default component.exports